"use client"

import { Toaster as Sonner, type ToasterProps } from "sonner"

import {
  ErrorIcon,
  InfoIcon,
  LoadingIcon,
  SuccessIcon,
  WarningIcon,
} from "@/icons"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <SuccessIcon className="text-success size-4" />,
        info: <InfoIcon className="text-brand size-4" />,
        warning: <WarningIcon className="text-warning size-4" />,
        error: <ErrorIcon className="text-destructive size-4" />,
        loading: <LoadingIcon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-surface-primary! text-content-primary! border-border! shadow-lg rounded-md grid! grid-cols-[minmax(0,1fr)] items-start! gap-x-3! gap-y-0! p-4! pr-12! has-[[data-icon]]:grid-cols-[1rem_minmax(0,1fr)] [&>[data-content]]:min-w-0 [&>[data-content]]:gap-1! [&>[data-content]]:wrap-anywhere [&>[data-button]]:col-start-1! [&>[data-button]]:mt-3! [&>[data-button]]:ml-0! [&>[data-button]]:justify-self-start [&:has([data-icon])>[data-button]]:col-start-2!",
          icon: "mt-0.5",
          title: "font-semibold text-sm text-content-primary!",
          description: "text-content-secondary! text-sm",
          actionButton:
            "bg-transparent! text-brand! hover:underline font-normal text-sm px-0! h-auto! min-h-6 whitespace-normal text-left",
          cancelButton: "bg-surface-tertiary! text-content-secondary!",
          closeButton:
            "text-content-secondary! hover:text-content-primary! left-auto! right-2! top-2! transform-none! border-none! rounded-md! bg-transparent! size-8! focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2 [&>svg]:size-4!",
          error: "bg-surface-primary! border-border!",
          success: "bg-surface-primary! border-border!",
          info: "bg-surface-primary! border-border!",
        },
      }}
      {...props}
    />
  )
}
export { Toaster }
